enum MAIN_PATHS {
	AUTH = "oauth2callback",
	REGION = "regions",
	MEETINGS = "meetings",
	STREAM = "streams",
	SCROLL = "scroll",
	AUTHORIZATION = "auth",
	PING = "ping",
	USER = "user",
	PROFILE = "profile",
	CORE = "core",
	DIVISION = "division",
	ROLE = "role",
	// 	slice
	USERS_FILTER = "usersFilter",
	USERS_REQUESTS_PASSWORD_FILTER = "usersRequestsPasswordFilter",
	DIVISIONS_EXPANDED = "divisionsExpanded",
	THEME = "theme",

	//
	LOYALTY_PROGRAM = "loyalty-program",
	REFERRAL_PROGRAM = "referral-program",
}

export default MAIN_PATHS;
